import { render, staticRenderFns } from "./QuotationLOPDetail.vue?vue&type=template&id=846bdd16&scoped=true&"
import script from "./QuotationLOPDetail.vue?vue&type=script&lang=js&"
export * from "./QuotationLOPDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuotationLOPDetail.vue?vue&type=style&index=0&id=846bdd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846bdd16",
  null
  
)

export default component.exports